import api from '.'

function _req (method, path, token, data, success, fail) {
  api.unauthenticatedRequest(method, path, data, success, fail, {
    extraHeaders: { Authorization: `Bearer ${token}` }
  })
}

export const consentSessions = {
  create (documentId, data, success, fail) {
    api.unauthenticatedRequest('POST', `/consentDocuments/${documentId}/sessions`, data, success, fail)
  },

  get (documentId, sessionId, token, success, fail) {
    _req('GET', `/consentDocuments/${documentId}/sessions/${sessionId}`, token, null, success, fail)
  },

  update (documentId, sessionId, token, data, success, fail) {
    _req('PUT', `/consentDocuments/${documentId}/sessions/${sessionId}`, token, data, success, fail)
  },

  postEvent (documentId, sessionId, token, data, success, fail) {
    _req('POST', `/consentDocuments/${documentId}/sessions/${sessionId}/events`, token, data, success, fail)
  },

  complete (documentId, sessionId, token, data, success, fail) {
    _req('POST', `/consentDocuments/${documentId}/sessions/${sessionId}/complete`, token, data, success, fail)
  },

  requestVerification (documentId, sessionId, token, method, success, fail) {
    _req('POST', `/consentDocuments/${documentId}/sessions/${sessionId}/verifications/${method}`, token, {}, success, fail)
  },

  verifyVerification (documentId, sessionId, token, method, code, success, fail) {
    _req('POST', `/consentDocuments/${documentId}/sessions/${sessionId}/verifications/${method}/verify`, token, { code }, success, fail)
  },

  createIdentityVerification (documentId, sessionId, token, success, fail) {
    _req('POST', `/consentDocuments/${documentId}/sessions/${sessionId}/identity-verifications`, token, null, success, fail)
  },

  getIdentityVerification (documentId, sessionId, token, verificationId, success, fail) {
    _req('GET', `/consentDocuments/${documentId}/sessions/${sessionId}/identity-verifications/${verificationId}`, token, null, success, fail)
  }
}
